import type { FC } from 'react';
import { Icon } from '@patternfly/react-core/dist/dynamic/components/Icon';
import { ArrowCircleUpIcon } from '@patternfly/react-icons/dist/dynamic/icons/arrow-circle-up-icon';
import { ResourcesAlmostFullIcon } from '@patternfly/react-icons/dist/dynamic/icons/resources-almost-full-icon';
import { ResourcesFullIcon } from '@patternfly/react-icons/dist/dynamic/icons/resources-full-icon';
import { SyncAltIcon } from '@patternfly/react-icons/dist/dynamic/icons/sync-alt-icon';
import { UnknownIcon } from '@patternfly/react-icons/dist/dynamic/icons/unknown-icon';
import type { ColoredIconProps } from '@console/dynamic-plugin-sdk';

export {
  GreenCheckCircleIcon,
  RedExclamationCircleIcon,
  YellowExclamationTriangleIcon,
  BlueInfoCircleIcon,
} from '@console/dynamic-plugin-sdk';

export const GrayUnknownIcon: FC<ColoredIconProps> = ({ className, title, size }) => (
  <Icon size={size}>
    <UnknownIcon className={className} title={title} />
  </Icon>
);

export const BlueSyncIcon: FC<ColoredIconProps> = ({ className, title, size }) => (
  <Icon status="info" size={size}>
    <SyncAltIcon className={className} title={title} />
  </Icon>
);

export const RedResourcesFullIcon: FC<ColoredIconProps> = ({ className, title, size }) => (
  <Icon status="danger" size={size}>
    <ResourcesFullIcon className={className} title={title} />
  </Icon>
);

export const YellowResourcesAlmostFullIcon: FC<ColoredIconProps> = ({ className, title, size }) => (
  <Icon status="warning" size={size}>
    <ResourcesAlmostFullIcon className={className} title={title} />
  </Icon>
);

export const BlueArrowCircleUpIcon: FC<ColoredIconProps> = ({ className, title, size }) => (
  <Icon status="info" size={size}>
    <ArrowCircleUpIcon className={className} title={title} />
  </Icon>
);
